import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLink from '../../../../library/form/components/FormLink';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import { UiView, UiViewHeading, UiTitle, UiAction } from "../../../../library/layout/Index";
import DocAdminInfo from '../../../cmn/DocAdminInfo';

const TaskHeaderViewer = (props) => {
    const { formObject } = props;
    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Task Detail' />
                    </span>
                </UiTitle>

                <UiAction>
                    <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>

            <div className="uiSingleColumn phViewContent">
                <div className="uiGridCol">
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskId" }} value="ID" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "taskId" }} className="uiVal uiHighlightKey" />
                            <FormROValue format="#" className="uiPriority" formObject={formObject} rowKey="" action={{ paramName: "priority" }} />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profile" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="" />
                            </span>
                            <FormLink formObject={formObject} rowKey="" linkProp={{ target: "_blank" }} className="uiVal uiLink"
                                action={{ paramName: "profile", actionId: "show", actionName: "proComp",  containerKey: "popup" }}
                            />
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profile2" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile2" }} value="" />
                            </span>
                            <FormLink formObject={formObject} rowKey="" linkProp={{ target: "_blank" }} className="uiVal uiLink"
                                action={{ paramName: "profile2", actionId: "show", actionName: "proComp",  containerKey: "popup" }}
                            />
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "type1" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type1" }} value="Task Type" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "type1" }} className="uiVal" />
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "type2" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type2" }} value="Call Type" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "type2" }} className="uiVal" />
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "area" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "area" }} value="Task Area" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "area" }} className="uiVal" />
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskDesc" }} value="Task Description" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "taskDesc" }} className="uiVal uiWrapAny" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "preReq" }} value="Pre Requisite" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "preReq" }} className="uiVal uiWrapAny" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "solution" }} value="Solution" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "solution" }} className="uiVal uiWrapAny" />
                        </li>
                    </ul>
                </div>
            </div>
        </UiView>
    )
}

export default withView(TaskHeaderViewer, "taskHeader", "taskDetail")